import { Box, Portal } from '@chakra-ui/react';

import { OverlayProps } from './overlay.props';

export const Overlay = ({
    children,
    isActive = false,
    ...rest
}: OverlayProps): JSX.Element | null => {
    return isActive ? (
        <Portal>
            <Box
                position={'fixed'}
                top={0}
                left={0}
                w={'100%'}
                h={'100%'}
                backgroundColor={'blackAlpha.600'}
                zIndex={'modal'}
                {...rest}
            >
                {children}
            </Box>
        </Portal>
    ) : null;
};
